import { render, staticRenderFns } from "./zdgllb.vue?vue&type=template&id=a370ff50&scoped=true&"
import script from "./zdgllb.vue?vue&type=script&lang=js&"
export * from "./zdgllb.vue?vue&type=script&lang=js&"
import style0 from "./zdgllb.vue?vue&type=style&index=0&id=a370ff50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a370ff50",
  null
  
)

export default component.exports